// extracted by mini-css-extract-plugin
export default {"heading":"_2rsbZ"};